import "./contentStyles.scss";
import P1 from "../../../../assets/professor-images/image 3.png";
import P2 from "../../../../assets/professor-images/Rectangle 28.png";
import P3 from "../../../../assets/professor-images/Rectangle 27.png";
import P4 from "../../../../assets/professor-images/Rectangle 26.png";

const Content = () => {
  return (
    <div className="wrapper">
      <div className="peopleHeader" style={{justifyContent:'center', display: 'flex'}}>
        <h2 style={{maxWidth: '40%'}}>Hear what our Scholars say about the program!</h2>
      </div>

      <div className="peopleContainer" id="player">
        <div>
          <iframe src="https://player.vimeo.com/video/953200860?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="I-ASCEND"></iframe>
        </div>
      </div>


      <div className="peopleHeader">
        <h2>Meet the Program Directors</h2>
      </div>

      <div className="peopleContainer">
        <div className="person-card-wrapper">
          <div className="img-wrapper">
            <img src={P1} alt="Dr. Sundeep Rayat" />
          </div>
          <div className="content">
            <span>Dr. Sundeep Rayat</span>
            <small>Principal Investigator</small>
            <small>Professor of Chemistry</small>
            <a className="tel" href="tel: +17652858308">
              (765) 285-8308
            </a>
            <a href="mailto:srayat@bsu.edu">srayat@bsu.edu</a>
          </div>
        </div>
        <div className="person-card-wrapper">
          <div className="img-wrapper">
            <img src={P2} alt="Dr. Gennifer Mager" />
          </div>
          <div className="content">
            <span>Dr. Gennifer Mager</span>
            <small>Co-Principal Investigator</small>
            <small>Associate Teaching Professor of Biology</small>
            <a className="tel" href="tel: +17652858886">
              (765) 285-8886
            </a>
            <a href="mailto:gmmager@bsu.edu">gmmager@bsu.edu</a>
          </div>
        </div>
        <div className="person-card-wrapper">
          <div className="img-wrapper">
            <img src={P3} alt="Dr. Katharine Herbert" />
          </div>
          <div className="content">
            <span>Dr. Katharine Herbert</span>
            <small>Co-Principal Investigator</small>
            <small>Assistant Director of Veterans Affairs, Financial Aid and Scholarships</small>
            <a className="tel" href="tel: +17652858686">
              (765) 285-8686
            </a>
            <a href="mailto:kjhernert@bsu.edu">kjhernert@bsu.edu</a>
          </div>
        </div>
        <div className="person-card-wrapper">
          <div className="img-wrapper">
            <img src={P4} alt="Professor Sundeep" />
          </div>
          <div className="content">
            <span>Dr. Jill Coleman</span>
            <small>S-STEM Administrator</small>
            <small>Associate Dean, College of Sciences and Humanities</small>
            <a className="tel" href="tel: +17652851042">
              (765) 285-1042
            </a>
            <a href="mailto:jscoleman@bsu.edu">jscoleman@bsu.edu</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
